import { UPSELL_PRICES } from '../../constants/bookingFare';
import { PHONE } from '../../constants/site';

const MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

export function ContactFields() {
  return (
    <div className="booking-grid booking-grid--2 contact-inquiry-form">
      <label>
        Mobile number
        <input name="contactPhone" type="tel" required placeholder={`e.g. ${PHONE}`} />
      </label>
      <label>
        Email address
        <input name="contactEmail" type="email" required placeholder="you@email.com" />
      </label>
    </div>
  );
}

export function PassengerFields({ prefix = '' }) {
  const p = prefix ? `${prefix}_` : '';
  return (
  <>
    <div className="booking-grid booking-grid--4 contact-inquiry-form">
      <label>
        Title
        <select name={`${p}title`} defaultValue="Mr" required>
          <option value="Mr">Mr</option>
          <option value="Mrs">Mrs</option>
          <option value="Ms">Ms</option>
          <option value="Dr">Dr</option>
        </select>
      </label>
      <label>
        First name
        <input name={`${p}firstName`} type="text" required />
      </label>
      <label>
        Middle name
        <input name={`${p}middleName`} type="text" />
      </label>
      <label>
        Last name
        <input name={`${p}lastName`} type="text" required />
      </label>
    </div>
    <div className="booking-grid booking-grid--4 contact-inquiry-form">
      <label>
        Gender
        <select name={`${p}gender`} defaultValue="Male" required>
          <option value="Male">Male</option>
          <option value="Female">Female</option>
          <option value="Other">Other</option>
        </select>
      </label>
      <label>
        Day
        <select name={`${p}dobDay`} defaultValue="1" required>
          {Array.from({ length: 31 }, (_, i) => (
            <option key={i + 1} value={String(i + 1)}>
              {i + 1}
            </option>
          ))}
        </select>
      </label>
      <label>
        Month
        <select name={`${p}dobMonth`} defaultValue="January" required>
          {MONTHS.map((m) => (
            <option key={m} value={m}>
              {m}
            </option>
          ))}
        </select>
      </label>
      <label>
        Year
        <select name={`${p}dobYear`} defaultValue="1990" required>
          {Array.from({ length: 80 }, (_, i) => {
            const y = new Date().getFullYear() - 18 - i;
            return (
              <option key={y} value={String(y)}>
                {y}
              </option>
            );
          })}
        </select>
      </label>
    </div>
  </>
  );
}

export function BillingFields() {
  return (
    <>
      <div className="booking-grid booking-grid--2 contact-inquiry-form">
        <label className="booking-grid--span-2">
          Street address
          <input name="billingStreet" type="text" required />
        </label>
        <label>
          Apt / suite
          <input name="billingApt" type="text" />
        </label>
        <label>
          City
          <input name="billingCity" type="text" required />
        </label>
        <label>
          Country
          <select name="billingCountry" defaultValue="United States" required>
            <option>United States</option>
            <option>Canada</option>
            <option>United Kingdom</option>
            <option>India</option>
            <option>Other</option>
          </select>
        </label>
        <label>
          State
          <input name="billingState" type="text" required />
        </label>
        <label>
          Postal / zip code
          <input name="billingZip" type="text" required />
        </label>
      </div>
    </>
  );
}

export function UpsellOptions({
  webCheckIn = 'no',
  onWebCheckInChange,
  cancellationProtection = 'no',
  onCancellationProtectionChange,
}) {
  return (
    <>
      <label className="booking-upsell">
        <div>
          <strong>Web check-in</strong>
          <span>USD {UPSELL_PRICES.webCheckIn.toFixed(2)} — We check you in online before departure</span>
        </div>
        <select
          name="webCheckIn"
          value={webCheckIn}
          onChange={(e) => onWebCheckInChange?.(e.target.value)}
        >
          <option value="no">No thanks</option>
          <option value="yes">Add to booking</option>
        </select>
      </label>
      <fieldset className="booking-fieldset">
        <legend>Cancellation protection — USD {UPSELL_PRICES.cancellationProtection.toFixed(2)}</legend>
        <label className="booking-radio">
          <input
            type="radio"
            name="cancellationProtection"
            value="yes"
            checked={cancellationProtection === 'yes'}
            onChange={() => onCancellationProtectionChange?.('yes')}
          />
          Yes, please add cancellation protection
        </label>
        <label className="booking-radio">
          <input
            type="radio"
            name="cancellationProtection"
            value="no"
            checked={cancellationProtection === 'no'}
            onChange={() => onCancellationProtectionChange?.('no')}
          />
          No, I will pass
        </label>
      </fieldset>
    </>
  );
}
